import { useSearchParams } from 'react-router-dom';
import MainPagetitle from '../../../layouts/MainPagetitle';
import ActionRemarks from '../Grievance/components/ActionRemarks';
import ActivityLogs from '../Grievance/components/ActivityLogs';
import ComplaintDetails from '../Grievance/components/ComplaintDetails';
import GrievanceHeaderInfo from '../Grievance/components/GrievanceHeaderInfo';
import GrievanceProcessProgress from '../Grievance/components/GrievanceProcessProgress';
import ResolutionBlock from '../Grievance/components/ResolutionBlock';

const GrievanceView = () => {
  const [searchParams] = useSearchParams();
  const viewType = searchParams.get('type') || 'general'; // 'assigned', 'general', 'escalated', 'customer'

  // Dummy data based on view type
  const grievanceData = {
    grievanceId: 'AFI-2026-0001',
    receivedOn: '22-09-2025, 10:12 AM',
    sla: viewType === 'escalated' ? 'SLA Timed Out' : 'SLA: 2 day',
    type: viewType === 'general' ? 'GENERAL' : null,
    customerName: 'John Doe',
    customerPhone: '9988776655',
    customerLan: 'LAN-88402',
    assignedTo: 'Shubham (Grievance Officer)',
    previouslyAssignedTo: viewType === 'escalated' ? 'Shubham (Compliance Officer)' : null,
    assignedOn: viewType === 'escalated' ? '22 Jun , 2025, 11:35 am' : null,
    escalatedOn: viewType === 'escalated' ? '22-09-2025, 10:12 AM' : null,
    currentStage:
      viewType === 'general'
        ? 'In Progress'
        : viewType === 'customer'
          ? 'Awaiting Your Review'
          : 'Pending',
    complaint: {
      category: 'Loan Account Related (Disbursement, EMI Debits, Excess Charges)',
      title: 'Excess Interest Charges Debited',
      explanation:
        'My EMI for June was debited twice and an extra interest surcharge was levied without prior notice. Please refund the excess charge.',
      attachments: ['transaction_receipt.pdf', 'transaction 01_receipt.pdf'],
    },
    logs: [
      {
        timestamp: '25 May, 10:15 AM',
        actionType: 'Assign',
        actionBy: 'Employee',
        actionDetails: 'Assigned to Shubham (Grievance Officer) for ledger review.',
      },
      {
        timestamp: '25 May, 10:15 AM',
        actionType: 'Log',
        actionBy: 'Customer',
        actionDetails: 'Grievance ticket created via Web Portal.',
      },
    ],
  };

  // Derived states based on context
  const showProgress = viewType === 'general' || viewType === 'customer';
  const showPreviousResolution = viewType === 'escalated';
  const showCustomerResolution = viewType === 'customer';

  // Page Title based on type
  let parentTitle = 'Assigned Complaints';
  if (viewType === 'general') parentTitle = 'Grievance';
  if (viewType === 'escalated') parentTitle = 'Escalated Complaints';
  if (viewType === 'customer') parentTitle = 'My Complaints';

  let mainTitle = viewType === 'general' ? 'View Grievance Detail' : 'Complaints Details';
  if (viewType === 'customer') mainTitle = ''; // Usually handled differently or no breadcrumbs

  return (
    <>
      <MainPagetitle
        mainTitle="Grievance"
        back="View Grievance Detail"
        backLink="/app/grievance"
        pageIcon={imagepaths.GrievanceIconActive}/>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <GrievanceHeaderInfo {...grievanceData} />
          </div>
        </div>

        <div className="row g-3">
          {/* Grievance Process Progress */}
          {showProgress && (
            <div className="col-xl-4 col-lg-5">
              <GrievanceProcessProgress
                currentStatus={viewType === 'general' ? 'In Progress' : 'Resolved'}
              />
            </div>
          )}

          <div className={showProgress ? 'col-xl-8 col-lg-7' : 'col-12'}>
            {/* Complaint Details */}
            <ComplaintDetails details={grievanceData.complaint} />
          </div>

          <div className="col-12">

            {/* Resolution Provided */}
            {showPreviousResolution && (
              <ResolutionBlock
                title="Previous Resolution (By Compliance Officer)"
                resolutionText="No resolution provided before SLA breached"
                description="The complaint has been escalated to you for review and resolution."
              />
            )}
            {showCustomerResolution && (
              <ResolutionBlock
                title="Resolution Provided"
                description="We have investigated the issue and found that there is an excess interest charges has been debited due to system error. the extra amount has been reversed and credited back to your account on 27-09-2025."
                resolvedBy="Grievance Officer"
                resolutionDate="27-09-2025, 10:15 AM"
              />
            )}

            {/* Comment */}
            {!showCustomerResolution && (
              <ActionRemarks
                label={viewType === 'general' ? 'Comment' : 'Resolution Remarks *'}
                placeholder="Please enter"
                buttons={
                  viewType === 'general'
                    ? [
                        { label: 'Close', className: 'btn-danger light' },
                        { label: 'Save', className: 'btn-primary' },
                      ]
                    : [
                        { label: 'Save As Draft', className: 'btn-danger light' },
                        { label: 'Submit Resolution', className: 'btn-primary' },
                      ]
                }
              />
            )}

            {/* Activity Logs */}
            <ActivityLogs logs={grievanceData.logs} />

            {showCustomerResolution && (
              <div className="d-flex justify-content-end gap-3 mb-4">
                <button className="btn btn-danger light">Reopen Complaint</button>
                <button className="btn btn-primary">Accept & Close Complaint</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(GrievanceView);
